import { CancelReason, FusionError } from '@fusion-advantage/backcompat'
import { DisplayExport } from "@fusion-advantage/formlib"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

// we allow these properties to be null in the instant during
// dashboardMw updateDashboardDetailResult while the export is loading
// to avoid having a momentarily 'expected not null' error flash on screen
export interface DashboardMwResultSliceState {
	error: FusionError|null
	displayExp: DisplayExport|null
	pendingSync: boolean
	cancelReasons: CancelReason[]
}

const initialState: DashboardMwResultSliceState = {
	error: null,
	displayExp: null,
	pendingSync: false,
	cancelReasons: [],
}

const dashboardMwResultSlice = createSlice({
	name: 'dashboardMwResult',
	initialState,
	reducers: {
		setDashboardMwResult(state, action: PayloadAction<DashboardMwResultSliceState|null>) {
			return action.payload ?? initialState
		},
	},
})

export const { setDashboardMwResult } = dashboardMwResultSlice.actions
export default dashboardMwResultSlice.reducer
